import React, { useState, useRef } from 'react'
import Markdown from 'react-markdown'
import animateScrollTo from 'animated-scroll-to'
import { updateSearchParams } from '../search/updateSearchParams.js'
import PageNumberBar from '../search/PageNumberBar/PageNumberBar.jsx'
import ShowingResultsCount from '../search/PageNumberBar/ShowingResultsCount.jsx'
import { LoadinDots } from '../shared_components/loadin_dots/LoadinDots.jsx'

import BCSupplierCard from './BCSupplierCard'
import BCSuppliersForm from './BCSuppliersForm.jsx'

import './BCSuppliersResults.scss'

import Mail from './mail.svg'
import Clipboard from './clipboard.svg'

const MAX_SUPPLIERS_PER_PAGE = 5

const initialURLParams = new URLSearchParams(window.location.search)

const BCSuppliersResults = ({
  location,
  setLocation,
  onSearch,
  navigateResponse,
  lexicon,
}) => {
  const [isCondensed, setIsCondensed] = useState(true)
  const [activePageNum, setActivePageNum] = useState(
    parseInt(initialURLParams.get('page')) || 1
  )
  const [searchedLocation, setSearchedLocation] = useState(location) // cache the thing we've actually searched for

  const supplierCount = navigateResponse.suppliers.length
  const pageNumbersToShow =
    supplierCount > MAX_SUPPLIERS_PER_PAGE * 4
      ? [1, 2, 3, 4, 5]
      : [
          ...Array(Math.ceil(supplierCount / MAX_SUPPLIERS_PER_PAGE)).keys(),
        ].map((i) => i + 1)

  const firstSupplierIndex = MAX_SUPPLIERS_PER_PAGE * (activePageNum - 1)
  const lastSupplierIndex = MAX_SUPPLIERS_PER_PAGE * activePageNum
  const paginatedSuppliers = navigateResponse.suppliers.slice(
    firstSupplierIndex,
    lastSupplierIndex
  )

  const topOfCardsRef = useRef()

  const handleSearchSubmit = () => {
    setIsCondensed(true)
    setSearchedLocation(location)
    onSearch()
  }

  // when we switch to a new page, also update the URL and history
  const updatePageNumber = (pageNum) => {
    const scrollTarget = topOfCardsRef.current.offsetTop - 60 // top of cards
    animateScrollTo(scrollTarget, { speed: 200 })
    updateSearchParams({ page: pageNum })
  }

  const fact = (icon, text) => {
    return (
      <div className="fact">
        <div className="icon">
          <img src={icon} alt="" />
        </div>
        <Markdown className="text" source={text} />
      </div>
    )
  }
  return (
    <div className="BCSuppliersResults">
      <div className="top-part">
        <div className="title">{lexicon.get('title')}</div>

        <BCSuppliersForm
          lexicon={lexicon}
          location={location}
          setLocation={setLocation}
          onSearch={handleSearchSubmit}
          isCondensed={isCondensed}
          setIsCondensed={setIsCondensed}
          showTitle={false}
        />

        <div className="gtk">
          <div className="gtk-title">{lexicon.get('gtk')}</div>
          {fact(Mail, lexicon.get('online_delivery_services_blurb'))}
          {fact(Clipboard, lexicon.get('skype'))}
        </div>
      </div>
      <div className="cards" ref={topOfCardsRef}>
        {/* eslint-disable-next-line no-nested-ternary -- jsx use-case ok */}
        {supplierCount > 0 ? (
          <ShowingResultsCount
            lexicon={lexicon}
            total={supplierCount}
            num1={activePageNum * MAX_SUPPLIERS_PER_PAGE - 4}
            num2={Math.min(
              activePageNum * MAX_SUPPLIERS_PER_PAGE,
              supplierCount
            )}
          />
        ) : // eslint-disable-next-line no-nested-ternary
        navigateResponse.status === 200 ? (
          <div className="no-results-container">
            {lexicon.get('no_results', { location: searchedLocation })}
          </div>
        ) : navigateResponse.status > 0 ? (
          <div className="no-results-container error">
            {lexicon.get('error_server')}
          </div>
        ) : (
          <div className="loading-container">
            <LoadinDots />
          </div>
        )}

        {paginatedSuppliers.map((supplier, idx) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <BCSupplierCard key={idx} supplier={supplier} lexicon={lexicon} />
          )
        })}

        <PageNumberBar
          setActivePageNum={setActivePageNum}
          activePageNum={activePageNum}
          pageNumbersToShow={pageNumbersToShow}
          totalClinicsSize={supplierCount}
          additionalClickHandler={updatePageNumber}
        />
      </div>
    </div>
  )
}

export default BCSuppliersResults
